// Msg
export const ADD_MSG = 'ADD_MSG';
export const CLEAR_MSGS = 'CLEAR_MSGS';
export const REMOVE_MSG = 'REMOVE_MSG'

// User
export const SET_USER = 'SET_USER'; 

// Leadgen
export const SET_APPLICATION = 'SET_APPLICATION';